(function(config) {
    'use strict';

    angular.module('machine.services', [
            'ngResource'
        ])
        .factory('machineDataSrvc', machineDataSrvc)
        .factory('machineSrvc', machineSrvc)
        .factory('machineActionsDataSrvc', machineActionsDataSrvc);

    machineDataSrvc.$inject = ['$resource', 'transformRequestSrvc'];

    function machineDataSrvc($resource, transformRequestSrvc) {
        return $resource(config.api + '/api/v1/machines/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET',
            },
            list: {
                method: 'GET',
                params: {
                    page: '@page'
                }
            },
            create: {
                method: 'POST',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            update: {
                method: 'PATCH',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            delete: {
                method: 'DELETE'
            },
            forProcessStage: {
                method: 'GET',
                url: config.api + '/api/v1/machines/admin_for_process_stage/',
                isArray: true
            }
        });
    }

    machineSrvc.$inject = ['machineDataSrvc', 'modalSrvc'];

    function machineSrvc(machineDataSrvc, modalSrvc) {

        return {
            remove: remove,
        };

        function remove(title, pk, successCallback, errorCallback) {
            modalSrvc.confirmRemove(
                title,
                function() {
                    machineDataSrvc.delete({
                        pk: pk
                    }).$promise.then(successCallback, errorCallback);
                }
            );
        }
    }

    machineActionsDataSrvc.$inject = ['$resource'];

    function machineActionsDataSrvc($resource) {
        return $resource(config.api + '/api/v1/machine_actions/', {}, {
            adminList: {
                method: 'GET',
                url: config.api + '/api/v1/machine_actions/admin_list/',
                isArray: true
            }
        });
    }


})(window.config);
